export const getUserDetails = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_USER_API_URL}/v1/getUser`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const handleUserRetakeAssement = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_USER_API_URL}/v1/updateUser/panel`,
    data,
  };
};

export const getCGMUsersFromList = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_USER_API_URL}/v1/applicable-cgm-users`,
    data,
  };
};

export const getUserState = (
  data: { [key: string]: any },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_USER_API_URL}/v1/userStates`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};
